var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _radialGradient, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoldMine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.249,
    x2: 333.079,
    xlinkHref: "#lg1",
    y1: 118.98,
    y2: 264.159
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.302,
    x2: 268.149,
    xlinkHref: "#lg2",
    y1: 190.037,
    y2: 440.471
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.804,
    x2: 246.11,
    xlinkHref: "#lg1",
    y1: 159.527,
    y2: 526.936
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.032,
    x2: 71.184,
    xlinkHref: "#lg2",
    y1: 371.152,
    y2: 491.328
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.75,
    x2: 95.929,
    xlinkHref: "#lg2",
    y1: 323.785,
    y2: 472.515
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.527,
    x2: 174.594,
    xlinkHref: "#lg2",
    y1: 178.098,
    y2: 486.604
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.639,
    x2: 489.842,
    xlinkHref: "#lg1",
    y1: 401.531,
    y2: 571.734
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.823,
    x2: 325.617,
    xlinkHref: "#lg2",
    y1: 389.179,
    y2: 542.827
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 497.52,
    x2: 261.52,
    xlinkHref: "#lg2",
    y1: 516.504,
    y2: 434.504
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.503,
    x2: 234.503,
    y1: 544.031,
    y2: 417.031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.514,
    x2: 165.514,
    xlinkHref: "#lg1",
    y1: 433.913,
    y2: 439.913
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.415,
    x2: 367.749,
    xlinkHref: "#lg1",
    y1: 439.895,
    y2: 434.562
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.822,
    x2: 256.822,
    xlinkHref: "#lg1",
    y1: 345,
    y2: 362.03
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 255,
    cy: 500.057,
    gradientUnits: "userSpaceOnUse",
    r: 82.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbed21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fbeb25",
    stopOpacity: 0.952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3408,
    stopColor: "#fde137",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ffdb42",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd945",
    stopOpacity: 0
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.559,
    x2: 251.58,
    xlinkHref: "#lg3",
    y1: 476.572,
    y2: 490.593
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.688,
    x2: 232.891,
    xlinkHref: "#lg4",
    y1: 481.701,
    y2: 471.903
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.759,
    x2: 257.883,
    xlinkHref: "#lg5",
    y1: 476.203,
    y2: 464.189
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.191,
    x2: 300.655,
    xlinkHref: "#lg3",
    y1: 480.579,
    y2: 503.043
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.408,
    x2: 270.712,
    xlinkHref: "#lg4",
    y1: 488.796,
    y2: 473.1
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.227,
    x2: 322.143,
    xlinkHref: "#lg5",
    y1: 486.639,
    y2: 470.473
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.855,
    x2: 312.562,
    xlinkHref: "#lg3",
    y1: 498.233,
    y2: 525.94
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 294.96,
    x2: 275.887,
    xlinkHref: "#lg4",
    y1: 509.223,
    y2: 490.149
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.885,
    x2: 324.994,
    xlinkHref: "#lg5",
    y1: 499.538,
    y2: 493.179
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.362,
    x2: 284.435,
    xlinkHref: "#lg3",
    y1: 491.438,
    y2: 528.511
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.937,
    x2: 234.915,
    xlinkHref: "#lg4",
    y1: 506.123,
    y2: 480.101
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.66,
    x2: 298.289,
    xlinkHref: "#lg5",
    y1: 494.355,
    y2: 483.816
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.747,
    x2: 231.853,
    xlinkHref: "#lg3",
    y1: 496.745,
    y2: 530.427
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.501,
    x2: 199.922,
    xlinkHref: "#lg4",
    y1: 506.853,
    y2: 482.274
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m341.658 94.982v-73.809c0-15.099-15.366-25.335-29.299-19.518l-94.085 39.277c-7.875 3.287-13.003 10.985-13.003 19.519v449.549h125.921 10.465 101.206v-340.232c0-14.664-8.922-27.853-22.534-33.309l-69.445-27.836c-5.572-2.235-9.226-7.636-9.226-13.641z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.331 136.459-69.445-27.836c-5.574-2.234-9.228-7.635-9.228-13.64v-48.488l-.419-.209v463.714h101.625v-340.233c0-14.663-8.922-27.852-22.533-33.308z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m244.599 195.686v-28.289c0-8.612-6.982-15.594-15.594-15.594-8.612 0-15.594-6.982-15.594-15.594v-29.52c0-11.847-10.693-20.824-22.361-18.773l-103.922 18.268c-9.114 1.602-15.761 9.519-15.761 18.773v105.642c0 14.067-7.603 27.035-19.878 33.905l-14.759 8.261c-11.671 6.533-19.162 18.609-19.829 31.968l-10.254 194.135c-.32 6.05 4.5 11.132 10.559 11.132h327.536c5.84 0 10.574-4.734 10.574-10.574v-192.758c0-15.749-8.634-30.231-22.488-37.721l-65.742-35.541c-13.854-7.489-22.487-21.971-22.487-37.72z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.514 286.23h99.206v223.77h-99.206z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.828 204.308h79.5v305.692h-79.5z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.829 268.948-65.742-35.541c-13.854-7.49-22.488-21.972-22.488-37.721v-28.289c0-8.685-7.106-15.489-15.79-15.595-8.522-.105-15.398-7.046-15.398-15.593v-29.52c0-11.847-10.693-20.824-22.361-18.773l-57.933 10.184c1.301 2.569 2.055 5.475 2.055 8.589v29.52c0 8.685 7.106 15.489 15.79 15.595 8.522.105 15.398 7.046 15.398 15.593v28.289c0 15.749 8.634 30.231 22.488 37.721l65.742 35.541c13.854 7.49 22.488 21.972 22.488 37.721v203.33h67.664c5.84 0 10.574-4.734 10.574-10.574v-192.756c.001-15.75-8.633-30.232-22.487-37.721z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.968 505.279v4.72h303.826c5.84 0 10.574-4.734 10.574-10.574v-20.309c0-6.228-3.366-11.969-8.8-15.011l-1.772-.992c-12.275-6.87-19.878-19.839-19.878-33.905v-105.64c0-9.254-6.647-17.171-15.761-18.773l-103.922-18.268c-11.668-2.051-22.361 6.926-22.361 18.773v29.52c0 8.612-6.982 15.594-15.594 15.594-8.612 0-15.594 6.982-15.594 15.594v28.289c0 15.749-8.634 30.231-22.488 37.721l-65.742 35.54c-13.854 7.49-22.488 21.972-22.488 37.721z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.365 479.122v20.304c0 5.84-4.734 10.574-10.574 10.574l-46.203-24.971c-13.853-7.489-22.479-21.971-22.479-37.723v-28.286c0-4.307-1.742-8.203-4.561-11.022-2.836-2.836-6.74-4.579-11.055-4.573-8.57.011-15.573-6.504-15.573-15.074v-30.04c0-11.856-10.695-20.833-22.358-18.777l-46.494 8.179c4.113-2.819 6.811-7.537 6.811-12.897v-29.52c0-11.844 10.683-20.821 22.358-18.777l103.924 18.268c9.11 1.609 15.752 9.521 15.752 18.777v105.642c0 14.07 7.61 27.04 19.878 33.911l1.771.991c5.435 3.043 8.803 8.785 8.803 15.014z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m492.789 509.999.002.001c1.095 0 2.152-.167 3.145-.476 4.305-1.338 7.432-5.354 7.432-10.099v-8.14l-141.533-141.532c-1.643-2.838-4.705-4.753-8.22-4.753h-193.586c-5.247 0-9.5 4.253-9.5 9.5 0 3.515 1.914 6.577 4.753 8.22.834 1.44 7.841 8.297 8.407 8.87l-36.189 138.409z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.115 510h-216.23l32.37-146h151.49z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.674 364-38.174 146h19.385l32.37-146z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.326 364h-13.581l32.37 146h19.385z",
    fill: "url(#SVGID_12_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m353.615 364h-193.586c-5.247 0-9.5-4.253-9.5-9.5 0-5.247 4.253-9.5 9.5-9.5h193.585c5.247 0 9.5 4.253 9.5 9.5.001 5.247-4.252 9.5-9.499 9.5z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.693 499.807c0-56.163-45.529-101.693-101.693-101.693s-101.693 45.53-101.693 101.693c0 3.44.173 6.84.507 10.193h202.372c.334-3.352.507-6.752.507-10.193z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 241.61,
    cy: 480.622,
    fill: "url(#SVGID_15_)",
    r: 10.826
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.61,
    cy: 480.622,
    fill: "url(#SVGID_16_)",
    r: 9.035
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.452 470.938c.73 1.457 1.142 3.102 1.142 4.843 0 5.979-4.847 10.826-10.826 10.826-1.741 0-3.385-.412-4.843-1.142 1.778 3.548 5.446 5.983 9.684 5.983 5.979 0 10.826-4.847 10.826-10.826.001-4.238-2.435-7.907-5.983-9.684z",
    fill: "url(#SVGID_17_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 284.68,
    cy: 487.068,
    fill: "url(#SVGID_18_)",
    r: 17.345
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.68,
    cy: 487.068,
    fill: "url(#SVGID_19_)",
    r: 14.476
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.439 471.553c1.17 2.335 1.829 4.97 1.829 7.759 0 9.579-7.766 17.345-17.345 17.345-2.789 0-5.424-.659-7.759-1.829 2.848 5.684 8.726 9.586 15.516 9.586 9.579 0 17.345-7.766 17.345-17.345 0-6.791-3.902-12.669-9.586-15.516z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m319.35 510h-52.98c.63-4.43 2.35-8.51 4.88-11.96.48-.66.98-1.28 1.52-1.89.11-.13.23-.26.34-.39.95-1.02 1.96-1.97 3.04-2.83.99-.8 2.05-1.53 3.15-2.17 1.58-.94 3.27-1.72 5.05-2.3v-.01c2.54-.85 5.26-1.33 8.08-1.37.14-.01.29-.01.43-.01 2.16 0 4.27.26 6.28.74.96.23 1.9.51 2.82.84.99.36 1.96.78 2.89 1.25.54.27 1.08.56 1.6.87.25.15.5.3.75.46.82.52 1.62 1.09 2.37 1.7.18.14.35.28.52.42.51.43 1 .88 1.47 1.34.15.15.31.3.45.45.11.11.22.22.31.33.16.16.31.32.45.48.21.23.41.45.6.69.15.17.29.35.43.53.62.77 1.2 1.58 1.72 2.41.16.26.32.52.47.78.32.54.61 1.07.87 1.62.1.2.2.39.28.59.22.45.42.91.59 1.37.2.48.38.97.54 1.46.09.28.18.55.26.83.12.38.22.76.31 1.15.08.3.15.6.21.9.04.16.07.32.1.48.08.41.15.83.2 1.24z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.86 510h-44c.55-3.26 1.82-6.28 3.64-8.89l.01-.01c.31-.46.64-.9 1-1.33.24-.31.5-.61.78-.91.74-.82 1.54-1.59 2.4-2.29.96-.8 2-1.51 3.1-2.14 1.56-.9 3.25-1.61 5.03-2.1.68-.19 1.36-.35 2.07-.47h.01c1.29-.24 2.61-.36 3.96-.36 1.85 0 3.66.23 5.38.65.94.23 1.86.53 2.74.88 2.26.87 4.34 2.11 6.17 3.64 3.99 3.31 6.8 8 7.71 13.33z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.15 508.76c.08.41.15.83.2 1.24h-12.95c.82-2.56 1.26-5.3 1.26-8.13 0-1.78-.18-3.52-.51-5.2-.46-2.39-1.25-4.66-2.3-6.77.54.27 1.08.56 1.6.87.25.15.5.3.75.46.82.52 1.62 1.09 2.37 1.7.18.14.35.28.52.42.51.43 1 .88 1.47 1.34.15.15.31.3.45.45.11.11.22.22.31.33.16.16.31.32.45.48.21.23.41.45.6.69.15.17.29.35.43.53.62.77 1.2 1.58 1.72 2.41.16.26.32.52.47.78.32.54.61 1.07.87 1.62.1.2.2.39.28.59.22.45.42.91.59 1.37.2.48.38.97.54 1.46.09.28.18.55.26.83.12.38.22.76.31 1.15.08.3.15.6.21.9.04.16.07.32.1.48z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m290.77 507.91c0 .7-.02 1.4-.07 2.09h-65.25c-.05-.69-.07-1.39-.07-2.09 0-7.93 2.82-15.2 7.51-20.86l.01-.01c.25-.3.5-.6.77-.89.06-.08.14-.16.21-.24s.15-.16.22-.24c1.17-1.26 2.44-2.43 3.79-3.49 2.87-2.25 6.12-4.03 9.63-5.23.67-.23 1.35-.44 2.04-.62.59-.16 1.19-.3 1.79-.43 2.17-.45 4.42-.69 6.72-.69 4.28 0 8.37.82 12.12 2.32h.01c.86.34 1.68.72 2.5 1.13.05.02.09.05.14.07.29.15.57.3.85.45.33.18.66.36.98.55.55.33 1.09.67 1.62 1.03.13.09.27.18.4.27.26.18.52.36.77.55.9.67 1.77 1.38 2.6 2.13.27.25.53.49.79.75.27.26.53.52.79.79.03.03.06.07.1.1.22.23.44.47.65.71.25.28.5.56.73.84.24.28.48.57.7.87.18.22.35.45.53.68v.01c.07.08.13.17.19.25.2.27.39.55.58.83.02.02.04.05.06.09.19.28.38.58.57.87.37.59.73 1.2 1.07 1.82v.01c.04.07.08.13.11.2.13.23.25.46.36.69.2.4.4.81.59 1.23.15.34.3.68.44 1.03.29.7.55 1.41.79 2.13.12.36.24.72.34 1.09.08.26.15.52.22.79.09.34.18.68.26 1.03 0 .01.01.02.01.03.03.12.05.24.08.37.07.31.13.62.19.94.1.51.18 1.03.25 1.56.04.27.07.54.1.81.05.43.09.86.12 1.3.03.36.05.72.06 1.08.02.43.03.86.03 1.3z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.36 507.91c0 .7-.03 1.4-.09 2.09h-54.4c-.06-.69-.09-1.39-.09-2.09 0-6.63 2.37-12.72 6.31-17.45.4-.49.82-.96 1.26-1.41.03-.04.06-.07.11-.11 1.21-1.26 2.56-2.41 4.01-3.42 2.44-1.7 5.17-3.02 8.11-3.85.61-.18 1.22-.33 1.85-.46 1.82-.39 3.71-.59 5.64-.59 3.49 0 6.83.66 9.89 1.86.91.34 1.8.74 2.65 1.19 1.76.91 3.41 2.01 4.92 3.27 1.38 1.14 2.64 2.42 3.77 3.82.93 1.15 1.76 2.37 2.49 3.67.25.43.49.86.71 1.31.91 1.82 1.62 3.77 2.1 5.8.23.93.41 1.89.53 2.86.15 1.15.23 2.32.23 3.51z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.77 507.91c0 .7-.02 1.4-.07 2.09h-19.14c1.56-2.61 2.76-5.46 3.54-8.48.15-.58.29-1.16.41-1.75.09-.44.17-.88.23-1.33.1-.6.18-1.2.24-1.81.11-1.1.17-2.21.17-3.34v-.36c-.02-2.05-.23-4.05-.62-5.99-.56-2.86-1.5-5.58-2.75-8.12-.03-.05-.05-.11-.08-.16.05.02.09.05.14.07.29.15.57.3.85.45.33.18.66.36.98.55.55.33 1.09.67 1.62 1.03.13.09.27.18.4.27.26.18.52.36.77.55.9.67 1.77 1.38 2.6 2.13.27.25.53.49.79.75.27.26.53.52.79.79.03.03.06.07.1.1.22.23.44.47.65.71.25.28.5.56.73.84.24.28.48.57.7.87.18.22.35.45.53.68v.01c.07.08.13.17.19.25.2.27.39.55.58.83.02.02.04.05.06.09.19.28.38.58.57.87.37.59.73 1.2 1.07 1.82v.01c.04.07.08.13.11.2.12.23.24.46.35.69h.01c.2.4.4.81.59 1.23.15.34.3.68.44 1.03.29.7.55 1.41.79 2.13.12.36.24.72.34 1.09.08.26.15.52.22.79.09.34.18.68.26 1.03v.03h.01c.03.12.05.24.08.37.07.31.13.62.19.94.1.51.18 1.03.25 1.56.04.27.07.54.1.81.05.43.09.86.12 1.3.03.36.05.72.06 1.08.02.43.03.86.03 1.3z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.22 509.18c0 .27 0 .55-.01.82h-62.83c-.01-.27-.01-.55-.01-.82 0-17.36 14.07-31.43 31.43-31.43 3.16 0 6.22.47 9.09 1.33.59.18 1.17.38 1.73.59 1.85.67 3.61 1.52 5.27 2.51 1.49.89 2.9 1.9 4.21 3.02.13.1.25.21.37.32 1.13.98 2.19 2.05 3.17 3.19.4.46.78.94 1.15 1.42 4.03 5.28 6.43 11.89 6.43 19.05z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.02 509.18c0 .27 0 .55-.02.82h-52.41c-.02-.27-.02-.55-.02-.82 0-14.48 11.74-26.23 26.23-26.23 3.48 0 6.8.68 9.84 1.91.77.31 1.51.66 2.24 1.05.23.11.46.23.68.36.1.05.2.11.3.17 1.27.73 2.48 1.56 3.6 2.5.1.07.2.16.3.25.83.69 1.61 1.44 2.34 2.24 0 0 0 0 .01.01 4.28 4.66 6.91 10.9 6.91 17.74z",
    fill: "url(#SVGID_28_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoldMine);
export default __webpack_public_path__ + "static/media/icon-gold-mine.5d12dfe373b1ebf41b4acbdf581df884.svg";
export { ForwardRef as ReactComponent };